/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatedSymbolAlternativeDto
 */
export interface CreatedSymbolAlternativeDto {
    /**
     * 
     * @type {string}
     * @memberof CreatedSymbolAlternativeDto
     */
    id: string;
}

export function CreatedSymbolAlternativeDtoFromJSON(json: any): CreatedSymbolAlternativeDto {
    return CreatedSymbolAlternativeDtoFromJSONTyped(json, false);
}

export function CreatedSymbolAlternativeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedSymbolAlternativeDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreatedSymbolAlternativeDtoToJSON(value?: CreatedSymbolAlternativeDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

